module.exports = "/assets/data/e6417ed53952d81680805d2f320d8265-GL3.data.json";